import { ConfigService } from '@services/config.service';
import { LocationSelectorService } from '@services/location_selector.service';
import { UnitService } from '@services/unit.service';
import { Scoped } from '@visiba/instantiation';
import { Presentation, SynchronousPresentation } from '@visiba/presentation';

interface PresentationModel {
	showLinkHome: boolean;
	showLinkMyCases: boolean;
	showLinkReceptionPicker: boolean;
}

// Source behind the logic within this controller.
// https://visibacare.slack.com/archives/CQ49U5C94/p1630938970003700?thread_ts=1623237044.004700&cid=CQ49U5C94

@Scoped()
export class HeaderNavController {
	public readonly presentation: SynchronousPresentation<PresentationModel>;

	constructor(
		private readonly unitService: UnitService,
		private readonly configService: ConfigService,
		private readonly locationSelectorService: LocationSelectorService,
	) {
		this.presentation = Presentation.create({
			showLinkHome: this.willShowHomeLink(),
			showLinkReceptionPicker: this.willShowReceptionPickerLink(),
			showLinkMyCases: true,
		});
	}

	private willShowHomeLink(): boolean {
		// Customer case:
		// - One one visible reception
		//    We don't want to show the home link to customers that only have one
		//    visible reception.
		return this.configService.getConfig(this.locationSelectorService.locationUnitId).hasMultipleLandingPages;
	}

	private willShowReceptionPickerLink(): boolean {
		// Customer cases:
		// - Show for a configuration with any listable reception.
		//    If any reception is tagged as listable, we show the reception picker link.
		// - Hide for a configuration with no listable reception.
		//    If for some reason this scenario is possible, we'd want to hide the
		//    reception picker since a user cannot pick any reception.
		let isVisible = false;
		for (const unit of this.unitService.units.values()) {
			if (unit.isEntrance && unit.isListed) {
				isVisible = true;
				break;
			}
		}

		return isVisible;
	}
}
